
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightDeckOff as ObiLightDeckOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-deck-off.js';
 
 
 

 
 export const ObiLightDeckOff = createComponent({
   react: React,
   tagName: 'obi-light-deck-off',
   elementClass: ObiLightDeckOffElement,
   events: {
     
   }
  });
 
 